// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import LiveTile from 'components/common/tile/LiveTile';
import EventTile from 'components/common/tile/EventTile';
import DvrTile from 'components/common/tile/DvrTile';
import VodTile from 'components/common/tile/VodTile';
import PromotionTile from 'components/common/tile/PromotionTile';

import { getSizeByLayout } from 'support/mediaTileHelper';

import Row from 'models/propTypes/row';
import Video from 'models/propTypes/video';
import { useCurrentVideoIds } from 'hooks/video';
import { isUpcoming } from 'support/videoHelper';
import { getImageUrl } from 'support/imageHelper';
import { getGamebyVideo } from 'support/scoringHelper';

const HomeTile = ({
  row,
  item,
  displayScoring,
  games,
  onClick,
  className,
  domRef,
  focusIdPrefix,
}) => {
  const history = useHistory();

  const onPromoClick = () => {
    const tag = item.tagKey;
    const { tagType } = item;
    let page = null;
    if (tagType.toLowerCase().includes('league')) {
      page = 'league';
    } else if (tagType.toLowerCase().includes('sport')) {
      page = 'sport';
    } else if (tagType.toLowerCase().includes('show')) {
      page = 'show';
    }

    if (tag && page) {
      history.push({
        pathname: `/${page}/${tag}`,
      });
    }
  };

  const game = displayScoring ? getGamebyVideo(item, games) : null;

  const [currentVideoId] = useCurrentVideoIds();
  if (item.type === 'PROMO') {
    const src = item.images
      ? getImageUrl(item.images.baseImage16X5, 1360)
      : null;
    return (
      <span className="flex-shrink-0" ref={domRef} key={item.id}>
        <PromotionTile
          ttsText={item.title}
          src={src}
          className={className}
          focusId={`row-${row.slug}-item-${item.id}`}
          onClick={onPromoClick}
        />
      </span>
    );
  }

  const {
    about: { title, shortTitle, duration, prefix, publishedOn },
    schedule: { videoStartDate },
    network,
    id,
    event: { status },
  } = item;

  const tileProps = {
    size: getSizeByLayout(row.layoutType),
    focusId: `${focusIdPrefix}row-${row.slug}-item-${id}`,
    className,
    src: item.images?.baseImage16X9,
    autoSizeSrc: true,
    alt: title,
    id: `${focusIdPrefix}row-${row.slug}-item-${id}`,
    isNowPlaying: id === currentVideoId,
    onClick: () => {
      onClick({ rowId: row.id, video: item, rowSlug: row.slug });
    },
    displayScoring,
    game,
  };

  switch (row.type) {
    case 'event': {
      const isLive = !isUpcoming(item);

      const eventProps = {
        title: shortTitle,
        prefix,
        brand: network,
      };
      return (
        <span className="flex-shrink-0" ref={domRef} key={item.id}>
          {isLive ? (
            <LiveTile
              {...eventProps}
              {...tileProps}
              authTypes={item.authTypes}
              startDate={videoStartDate * 1000}
              status={status}
            />
          ) : (
            <EventTile
              {...eventProps}
              {...tileProps}
              authTypes={item.authTypes}
              startDate={videoStartDate * 1000}
            />
          )}
        </span>
      );
    }
    case 'dvr': {
      const dvrProps = {
        title: shortTitle,
        timeSeconds: publishedOn,
      };
      return (
        <span className="flex-shrink-0" ref={domRef} key={item.id}>
          <DvrTile {...dvrProps} {...tileProps} />
        </span>
      );
    }
    default: {
      const vodProps = {
        title: shortTitle,
        duration,
        brand: network,
        authTypes: item.authTypes,
      };
      return (
        <span className="flex-shrink-0" ref={domRef} key={item.id}>
          <VodTile {...vodProps} {...tileProps} />
        </span>
      );
    }
  }
};

HomeTile.propTypes = {
  row: Row,
  item: Video,
  displayScoring: PropTypes.bool,
  games: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
  domRef: PropTypes.object,
  focusIdPrefix: PropTypes.string,
};

HomeTile.defaultProps = {
  row: {},
  item: {},
  displayScoring: false,
  games: null,
  onClick: () => null,
  className: null,
  domRef: null,
  focusIdPrefix: '',
};
export default React.memo(
  React.forwardRef((props, ref) => <HomeTile {...props} domRef={ref} />),
);
